



export const SidebarData1 = [
    
        {
          tittle: 'Main',
          hasSubRoute: true,
          icon: 'assets/img/icons/menu-icon.svg',
          showSubRoute: false,
          subRoutes: [
            {
              tittle: 'Dashboard',
              hasSubRoute: true,
              icon: 'assets/img/icons/dashboard.svg',
              showSubRoute: true,
              subRoutes: [
                {
                  tittle: 'Admin Dashboard',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/admin-dashboard",
                  subRoutes: [],
                },
                {
                  tittle: 'Sales Dashboard',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/sales-dashboard",
                  subRoutes: [],
                },
              ],
            },
            {
              tittle: 'Application',
              hasSubRoute: true,
              showSubRoute: true,
              base: 'application',
              subRoutes: [
                {
                  tittle: 'Chat',
                  route: "/chat",
                  hasSubRoute: false,
                  showSubRoute: false,
                  customSubmenuTwo: false,
                },
                // {
                //   tittle: 'Call',
                //   hasSubRoute: true,
                //   showSubRoute: true,
                //   base: 'application',
                //   subRoutes: [
                //     {
                //       tittle: 'Video Call',
                //       route: "/video-call",
                //       hasSubRoute: false,
                //       showSubRoute: false,
                //       subRoutes: [],
                //     },
                //     {
                //       tittle: 'Audio Call',
                //       route: "/audio-call",
                //       hasSubRoute: false,
                //       showSubRoute: false,
                //     },
                //     {
                //       tittle: 'Call History',
                //       route: "/call-history",
                //       hasSubRoute: false,
                //       showSubRoute: false,
                //     },
                //   ],
                // },
                {
                  tittle: 'Calendar',
                  route: "/calendar",
                  hasSubRoute: false,
                  showSubRoute: false,
                  customSubmenuTwo: false,
                },
                {
                  tittle: 'Email',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/email",
                  customSubmenuTwo: false,
                  subRoutes: [],
                },
                {
                  tittle: 'To Do',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/todo",
                  customSubmenuTwo: false,
                  subRoutes: [],
                },
                {
                  tittle: 'Notes',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/notes",
                  customSubmenuTwo: false,
                  subRoutes: [],
                },
                {
                  tittle: 'File Manager',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/file-manager",
                  customSubmenuTwo: false,
                  subRoutes: [],
                },
              ],
            },
          ],
        },
        {
          tittle: 'Inventory',
          hasSubRoute: true,
          icon: 'assets/img/icons/product.svg',
          showSubRoute: false,
          activeRoute: 'product',
          subRoutes: [
            {
              tittle: 'Products',
              hasSubRoute: false,
              showSubRoute: true,
              route:"/product-list",
              subRoutes: [],
            },
            {
              tittle: 'Create Product',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/add-product",
              subRoutes: [],
            },
            {
              tittle: 'Expired Products',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/expired-products",
              subRoutes: [],
            },
            {
              tittle: 'Low Stocks',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/low-stocks",
              subRoutes: [],
            },
            {
              tittle: 'Category',
              hasSubRoute: false,
              showSubRoute: false,
              route:"/category-list",
              subRoutes: [],
            },
            {
              tittle: 'Sub Category',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/sub-categories",
              subRoutes: [],
            },
            {
              tittle: 'Brands',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/brand-list",
              subRoutes: [],
            },
            {
              tittle: 'Units',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/units",
              subRoutes: [],
            },
            {
              tittle: 'Variant Attributes',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/variant-attributes",
              subRoutes: [],
            },
            {
              tittle: 'Warranties',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/warranty",
              subRoutes: [],
            },
            {
              tittle: 'Print Barcode',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/barcode",
              subRoutes: [],
            },
            {
              tittle: 'Print QR Code',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/qrcode",
              subRoutes: [],
            },
          ],
        },
        {
          tittle: 'Sales & Purchase',
          hasSubRoute: true,
          icon: 'assets/img/icons/purchase1.svg',
          showSubRoute: false,
          activeRoute: 'users',
          subRoutes: [
            {
              tittle: 'Sales',
              hasSubRoute: true,
              showSubRoute: false,
              route: "/sales-list",
              subRoutes: [
                {
                  tittle: 'Sales',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/sales-list",
                  subRoutes: [],
                },
                {
                  tittle: 'Invoice',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/invoice-settings",
                  subRoutes: [],
                },
                {
                  tittle: 'Sales Return',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/sales-returns",
                  subRoutes: [],
                },
                {
                  tittle: 'Quotation',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/quotation-list",
                  subRoutes: [],
                },
                {
                  tittle: 'POS',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/pos",
                  subRoutes: [],
                },
              ],
            },
            {
              tittle: 'Purchases',
              hasSubRoute: true,
              icon: 'assets/img/icons/purchase1.svg',
              showSubRoute: false,
              activeRoute: 'users',
              subRoutes: [
                {
                  tittle: 'Purchases',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/purchase-list",
                  subRoutes: [],
                },
                {
                  tittle: 'Purchase Order',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/purchase-order-report",
                  subRoutes: [],
                },
                {
                  tittle: 'Purchase Return',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/purchase-returns",
                  subRoutes: [],
                },
                {
                  tittle: 'ManageStock',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/manage-stocks",
                  subRoutes: [],
                },
                {
                  tittle: 'Stock Adjustment',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/stock-adjustment",
                  subRoutes: [],
                },
                {
                  tittle: 'Sub Category',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/sub-categories",
                  subRoutes: [],
                },
                {
                  tittle: 'Stock Transfer',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route:"/stock-transfer",
                  subRoutes: [],
                },
              ],
            },
            {
              tittle: 'Expenses',
              hasSubRoute: true,
              showSubRoute: true,
            //   route: routes.stockTransfer,
              subRoutes: [
                {
                  tittle: 'Expenses',
                  route: "/expense-list",
                },
                {
                  tittle: 'Expense Category',
                  route: "/expense-category",
                },
              ],
            },
          ],
        },
        {
          tittle: 'User Management',
          hasSubRoute: true,
          icon: 'assets/img/icons/users1.svg',
          showSubRoute: false,
          activeRoute: 'users',
          subRoutes: [
            {
              tittle: 'Roles & Permissions',
              hasSubRoute: true,
              showSubRoute: false,
            //   route: routes.users,
              subRoutes: [
                {
                  tittle: 'Roles & Permissions',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route:"/roles-permissions",
                  subRoutes: [],
                },
                {
                  tittle: 'Delete Account Request',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/delete-account",
                  subRoutes: [],
                },
              ],
            },
            {
              tittle: 'Base UI',
              hasSubRoute: true,
              icon: 'assets/img/icons/printer.svg',
              showSubRoute: false,
              activeRoute: 'users',
              subRoutes: [
                {
                  tittle: 'Alerts',
                  route: "/ui-alerts",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Accordion',
                  route: "/ui-accordion",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Avatar',
                  route: "/ui-avatar",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Badges',
                  route: "/ui-badges",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Border',
                  route: "/ui-borders",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Buttons',
                  route:"/ui-buttons",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Button Group',
                  route: "/ui-buttons-group",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Breadcrumb',
                  route: "/ui-breadcrumb",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Card',
                  route: "/ui-cards",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Carousel',
                  route:"/ui-carousel",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Colors',
                  route: "/ui-colors",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Dropdowns',
                  route: "/ui-dropdowns",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Grid',
                  route: "/ui-grid",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Images',
                  route: "/ui-images",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Lightbox',
                  route: "/ui-lightbox",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Media',
                  route: "/ui-media",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Modals',
                  route: "/ui-modals",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Offcanvas',
                  route: "/ui-offcanvas",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Pagination',
                  route: "/ui-pagination",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Popovers',
                  route: "/ui-popovers",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Progress',
                  route: "/ui-progress",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Placeholders',
                  route: "/ui-placeholders",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Range Slider',
                  route: "/ui-rangeslider",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Spinner',
                  route: "/ui-spinner",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Sweet Alerts',
                  route: "/ui-sweetalerts",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Tabs',
                  route: "/ui-nav-tabs",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Toasts',
                  route: "/ui-toasts",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Tooltips',
                  route: "/ui-tooltips",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Typography',
                  route: "/ui-typography",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Video',
                  route: "/ui-video",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
              ],
            },
            {
              tittle: 'Advanced UI',
              hasSubRoute: true,
              showSubRoute: false,
              activeRoute: 'users',
              subRoutes: [
                {
                  tittle: 'Ribbon',
                  route: "/ui-ribbon",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Clipboard',
                  route: "/ui-clipboard",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Drag & Drop',
                  route: "/ui-drag-drop",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Rating',
                  route: "/ui-rating",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Text Editor',
                  route:"/ui-text-editor",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Counter',
                  route: "/ui-counter",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Scrollbar',
                  route: "/ui-scrollbar",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
    
                {
                  tittle: 'Timeline',
                  route: "/ui-timeline",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
              ],
            },
            {
              tittle: 'Charts',
              hasSubRoute: true,
              showSubRoute: false,
              activeRoute: 'users',
              subRoutes: [
                {
                  tittle: 'Apex Charts',
                  route: "/chart-apex",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Ng2 Charts',
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "/chart-js",
                  subRoutes: [],
                },
               
              ],
            },
            {
              tittle: 'Primary-icons',
              hasSubRoute: true,
              showSubRoute: false,
              activeRoute: 'users',
              subRoutes: [
                {
                  tittle: 'Fontawesome Icons',
                  route: "/icon-fontawesome",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Feather Icons',
                  route: "/icon-feather",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Ionic Icons',
                  route: "/icon-ionic",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Material Icons',
                  route: "/icon-material",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Pe7 Icons',
                  route: "/icon-pe7",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
              ],
            },
            {
              tittle: 'Secondary-icons',
              hasSubRoute: true,
              showSubRoute: false,
              activeRoute: 'users',
              subRoutes: [
                {
                  tittle: 'Simpleline Icons',
                  route: "/icon-simpleline",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Themify Icons',
                  route:"/icon-themify",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Weather Icons',
                  route: "/icon-weather",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Typicon Icons',
                  route: "/icon-typicon",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Flag Icons',
                  route: "/icon-flag",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
              ],
            },
            {
              tittle: 'Forms',
              hasSubRoute: true,
              showSubRoute: false,
              activeRoute: 'users',
              subRoutes: [
                {
                  tittle: 'Basic Inputs',
                  route: "/form-basic-inputs",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Checkbox & Radios',
                  route: "/form-checkbox-radios",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Input Groups',
                  route:"/form-input-groups",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Form Select',
                  route:"/form-select",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Input Masks',
                  route: "/form-mask",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'File Uploads',
                  route: "/form-fileupload",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
              ],
            },
          ],
        },
        {
          tittle: 'Profile',
          hasSubRoute: true,
          icon: 'assets/img/icons/users1.svg',
          showSubRoute: false,
          subRoutes: [
            {
              tittle: 'Profile',
              route: "/profile",
              hasSubRoute: false,
              showSubRoute: false,
            },
            {
              tittle: 'Authentication',
              hasSubRoute: true,
              showSubRoute: false,
            //   route: routes.purchaseReport,
              subRoutes: [
                {
                  tittle: 'Login',
                  hasSubRoute: true,
                  showSubRoute: false,
                  route:"/signin",
                  subRoutes: [
                    {
                      tittle: 'Cover',
                      route: "/signin",
                      hasSubRoute: false,
                      showSubRoute: false,
                    },
                    {
                      tittle: 'Illustration',
                      route: "/signin-2",
                      hasSubRoute: false,
                      showSubRoute: false,
                    },
                    {
                      tittle: 'Basic',
                      route:"/signin-3",
                      hasSubRoute: false,
                      showSubRoute: false,
                    },
                  ],
                },
                {
                    tittle: 'Register',
                    hasSubRoute: true,
                    showSubRoute: false,
                    route:"/register",
                    subRoutes: [
                      {
                        tittle: 'Cover',
                        route: "/signin",
                        hasSubRoute: false,
                        showSubRoute: false,
                      },
                      {
                        tittle: 'Illustration',
                        route: "/signin-2",
                        hasSubRoute: false,
                        showSubRoute: false,
                      },
                      {
                        tittle: 'Basic',
                        route:"/signin-3",
                        hasSubRoute: false,
                        showSubRoute: false,
                      },
                    ],
                  },
                  {
                    tittle: 'Forgot Password',
                    hasSubRoute: true,
                    showSubRoute: false,
                    route: "/forgot-password",
                    subRoutes: [
                      {
                        tittle: 'Cover',
                        route: "/forgot-password",
                        hasSubRoute: false,
                        showSubRoute: false,
                      },
                      {
                        tittle: 'Illustration',
                        route: "/signin-2",
                        hasSubRoute: false,
                        showSubRoute: false,
                      },
                      {
                        tittle: 'Basic',
                        route:"/signin-3",
                        hasSubRoute: false,
                        showSubRoute: false,
                      },
                    ],
                  },
                  {
                    tittle: 'Reset Password',
                    hasSubRoute: true,
                    showSubRoute: false,
                    route: "/reset-password",
                    subRoutes: [
                      {
                        tittle: 'Cover',
                        route: "/signin",
                        hasSubRoute: false,
                        showSubRoute: false,
                      },
                      {
                        tittle: 'Illustration',
                        route: "/signin-2",
                        hasSubRoute: false,
                        showSubRoute: false,
                      },
                      {
                        tittle: 'Basic',
                        route:"/signin-3",
                        hasSubRoute: false,
                        showSubRoute: false,
                      },
                    ],
                  },
                  {
                    tittle: 'Email Verification',
                    hasSubRoute: true,
                    showSubRoute: false,
                    route: "/email-verification",
                    subRoutes: [
                      {
                        tittle: 'Cover',
                        route: "/signin",
                        hasSubRoute: false,
                        showSubRoute: false,
                      },
                      {
                        tittle: 'Illustration',
                        route: "/signin-2",
                        hasSubRoute: false,
                        showSubRoute: false,
                      },
                      {
                        tittle: 'Basic',
                        route:"/signin-3",
                        hasSubRoute: false,
                        showSubRoute: false,
                      },
                    ],
                  },
                  {
                    tittle: '2 Step Verification',
                    hasSubRoute: true,
                    showSubRoute: false,
                    route: "/two-step-verification",
                    subRoutes: [
                      {
                        tittle: 'Cover',
                        route: "/signin",
                        hasSubRoute: false,
                        showSubRoute: false,
                      },
                      {
                        tittle: 'Illustration',
                        route: "/signin-2",
                        hasSubRoute: false,
                        showSubRoute: false,
                      },
                      {
                        tittle: 'Basic',
                        route:"/signin-3",
                        hasSubRoute: false,
                        showSubRoute: false,
                      },
                    ],
                  },
              ],
            },
            {
              tittle: 'Pages',
              hasSubRoute: true,
              showSubRoute: false,
            //   route: routes.purchaseReport,
              subRoutes: [
                {
                  tittle: '404 Error',
                  hasSubRoute: true,
                  showSubRoute: false,
                  route:"/error-404",
                  subRoutes: [],
                },
                {
                  tittle: '500 Error',
                  hasSubRoute: true,
                  showSubRoute: false,
                  route:"/error-500",
                  subRoutes: [],
                },
                {
                  tittle: 'Blank page',
                  hasSubRoute: true,
                  showSubRoute: false,
                  route:"/blank-page",
                  subRoutes: [],
                },
                {
                  tittle: 'Comming Soon',
                  hasSubRoute: true,
                  showSubRoute: false,
                  route:"/coming-soon",
                  subRoutes: [],
                },
              ],
            },
            {
            tittle: 'Employees',
            hasSubRoute: true,
            showSubRoute: false,
            //   route: routes.purchaseReport,
            subRoutes: [
                {
                tittle: 'Employees',
                hasSubRoute: true,
                showSubRoute: false,
                route:"/employees-grid",
                subRoutes: [],
                },
                {
                tittle: 'Designations',
                hasSubRoute: true,
                showSubRoute: false,
                route:"/designation",
                subRoutes: [],
                },
                {
                tittle: 'Departments',
                hasSubRoute: true,
                showSubRoute: false,
                route:"/department-grid",
                subRoutes: [],
                },
                {
                tittle: 'Shifts',
                hasSubRoute: true,
                showSubRoute: false,
                route:"/shift",
                subRoutes: [],
                }
                
            ],
            },
            {
            tittle: 'Attendance',
            hasSubRoute: true,
            showSubRoute: false,
            //   route: routes.purchaseReport,
            subRoutes: [
                {
                tittle: 'Employee Attendance',
                hasSubRoute: true,
                showSubRoute: false,
                route:"/attendance-employee",
                subRoutes: [],
                },
                {
                tittle: 'Admin Attendance',
                hasSubRoute: true,
                showSubRoute: false,
                route:"/attendance-admin",
                subRoutes: [],
                },
            ],
            },
            {
                tittle: 'Leave & Holidays',
                hasSubRoute: true,
                showSubRoute: false,
                //   route: routes.purchaseReport,
                subRoutes: [
                    {
                    tittle: 'Admin Leaves',
                    hasSubRoute: true,
                    showSubRoute: false,
                    route:"/leaves-admin",
                    subRoutes: [],
                    },
                    {
                    tittle: 'Employee Leaves',
                    hasSubRoute: true,
                    showSubRoute: false,
                    route:"/leaves-employee",
                    subRoutes: [],
                    },
                    {
                        tittle: 'Leave Types',
                        hasSubRoute: true,
                        showSubRoute: false,
                        route:"/leave-types",
                        subRoutes: [],
                        },
                ],
                },
          ],
        },
        {
          tittle: 'Reports',
          hasSubRoute: true,
          icon: 'assets/img/icons/printer.svg',
          showSubRoute: false,
          activeRoute: 'users',
          subRoutes: [
            {
              tittle: 'Sales Report',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/sales-report",
              subRoutes: [],
            },
            {
              tittle: 'Purchase Report',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/purchase-report",
              subRoutes: [],
            },
            {
              tittle: 'Inventory Report',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory-report",
              subRoutes: [],
            },
            {
              tittle: 'Invoice Report',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/invoice-report",
              subRoutes: [],
            },
            {
              tittle: 'Supplier Report',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/supplier-report",
              subRoutes: [],
            },
           
            {
              tittle: 'Customer Report',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/customer-report",
              subRoutes: [],
            },
            {
              tittle: 'Expense Report',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/expense-report",
              subRoutes: [],
            },
            {
              tittle: 'Income Report',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/income-report",
              subRoutes: [],
            },
            {
              tittle: 'Tax Report',
              hasSubRoute: false,
              showSubRoute: false,
              route: "/tax-report",
              subRoutes: [],
            },
          ],
        },
        {
          tittle: 'Settings',
          hasSubRoute: true,
          icon: 'assets/img/icons/purchase1.svg',
          showSubRoute: false,
          activeRoute: 'users',
          subRoutes: [
            {
              tittle: 'General Settings',
              hasSubRoute: true,
              showSubRoute: false,
            //   route: routes.users,
              subRoutes: [
                {
                  tittle: 'Profile',
                  route:"/profile",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Security',
                  route: "/security-settings",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Notifications',
                  route: "/notification" ,
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Connected Apps',
                  route:  "/connected-apps",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
              ],
            },
            {
              tittle: 'Website Settings',
              hasSubRoute: true,
              showSubRoute: false,
              subRoutes: [
                {
                  tittle: 'System Settings',
                  route: "/system-settings",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Company Settings',
                  route: "/company-settings",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Localization',
                  route:"/localization-settings",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Prefixes',
                  route: "/prefixes",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Preference',
                  route: "/preference",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Appearance',
                  route: "/appearance",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Social Authentication',
                  route:"/social-authentication",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Language',
                  route: "/language-settings",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
              ],
            },
    
            {
              tittle: 'App Settings',
              hasSubRoute: true,
              icon: 'assets/img/icons/printer.svg',
              showSubRoute: false,
              activeRoute: 'users',
              subRoutes: [
                {
                  tittle: 'Invoice',
                  route: "/invoice-settings",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Printer',
                  route: "/printer-settings",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'POS',
                  route: "/pos-settings",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Custom Fields',
                  route: "/custom-fields",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
              ],
            },
            {
              tittle: 'System Settings',
              hasSubRoute: true,
              showSubRoute: false,
              activeRoute: 'users',
              subRoutes: [
                {
                  tittle: 'Email',
                  route:"/email-settings",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'SMS Gateways',
                  route: "/sms-gateway",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'OTP',
                  route: "/otp-settings",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'GDPR Cookies',
                  route: "/gdpr-settings",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
              ],
            },
            {
              tittle: 'Financial Settings',
              hasSubRoute: true,
              showSubRoute: false,
              activeRoute: 'users',
              subRoutes: [
                {
                  tittle: 'Payment Gateway',
                  route:"/payment-gateway-settings",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Bank Accounts',
                  route: "/bank-settings-grid",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Tax Rates',
                  route: "/tax-rates",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Currencies',
                  route: "/currency-settings",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
              ],
            },
            {
              tittle: 'Other Settings',
              hasSubRoute: true,
              showSubRoute: false,
              activeRoute: 'users',
              subRoutes: [
                {
                  tittle: 'Storage',
                  route: "/storage-settings",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
                {
                  tittle: 'Ban IP Address',
                  route: "/ban-ip-address",
                  hasSubRoute: false,
                  showSubRoute: false,
                },
              ],
            },
            {
              tittle: 'Documentation',
              hasSubRoute: false,
              showSubRoute: false,
              activeRoute: 'users',
            },
            {
              tittle: 'Changelog v2.0.7',
              hasSubRoute: false,
              showSubRoute: false,
              activeRoute: 'users',
            },
          ],
        },
    
];
